import { useMemo } from 'react';
import { useStudyDocuments } from '@/hooks/studies/useStudyDocuments';
import { updateDocumentCategory } from '@/hooks/submissions/useSubmissionDocuments';
import DocumentsTable, {
  getDocumentStatusBadge,
  type DocumentWithStatus,
} from '@/components/DocumentsTable';

interface StudyDocumentsProps {
  studyId: string;
  compact?: boolean;
}

const StudyDocuments = ({ studyId, compact }: StudyDocumentsProps) => {
  const { documents, isLoading, error, refetch } = useStudyDocuments(studyId);

  const documentsWithStatus: DocumentWithStatus[] = useMemo(() => {
    return documents.map(doc => {
      const badge = getDocumentStatusBadge(doc.document_status);
      return {
        ...doc,
        statusLabel: badge.label,
        statusClassName: badge.className,
      };
    });
  }, [documents]);

  const handleCategoryUpdate = async (
    documentId: string,
    submissionId: string,
    category: string
  ) => {
    await updateDocumentCategory(submissionId, documentId, category);
    await refetch();
  };

  return (
    <DocumentsTable
      documents={documentsWithStatus}
      isLoading={isLoading}
      error={error}
      onRetry={refetch}
      onCategoryUpdate={handleCategoryUpdate}
      collectionZipRoute={`/studies/${studyId}/documents/zip`}
      compact={compact}
    />
  );
};

export default StudyDocuments;
